import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLaragonComponent } from './simple-icons-laragon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLaragonComponent ],
    exports:      [ SimpleIconsLaragonComponent ],
    bootstrap:    []
})
export class SimpleIconsLaragonModule {}
